<template>
  <div class="radio-row">
    <div
      class="radio-block"
      :style="flexContentStyle"
      v-for="option in optionSet"
      :key="option.label"
      :class="{'center-block': label === 'top'}">
      <label
        v-if="label === 'top'"
        :for="labelId(option)"
        class="block-label"
        :class="{'text-muted': option.disabled }" > {{ option.label }} </label>
      <div class="mdc-form-field" :class="{'cursor-not-allowed':option.locked}">
        <LockableInputWrapper :locked="option.locked">
          <div
            class="mdc-radio"
            v-if="!multiSelect"
            :class="{ 'mdc-radio--disabled': option.disabled, 'locked': option.locked }">
            <input
              class="mdc-radio__native-control"
              type="radio"
              :id="labelId(option)"
              :value="option.label"
              v-model="selectedOption"
              :disabled="option.disabled || option.locked">
            <div class="mdc-radio__background">
              <div class="mdc-radio__outer-circle"/>
              <div class="mdc-radio__inner-circle"/>
            </div>
          </div>
          <div class="mdc-touch-target-wrapper" v-else-if="multiSelect">
            <div
              class="mdc-checkbox mdc-checkbox--touch"
              :class="{locked: option.locked}">
              <input
                type="checkbox"
                :class="['mdc-checkbox__native-control', {'cursor-not-allowed': option.locked}]"
                :id="labelId(option)"
                :value="option.label"
                v-model="selectedOptions"
                :disabled="option.disabled || option.locked">
              <div class="mdc-checkbox__background">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                </svg>
                <div class="mdc-checkbox__mixedmark"/>
              </div>
              <div class="mdc-checkbox__ripple"/>
            </div>
          </div>
        </LockableInputWrapper>
        <label
          v-if="label === 'right'"
          :for="labelId(option)"
          :class="{'text-muted': option.disabled }"> {{ option.label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import LockableInputWrapper from '@/components/LockableInputWrapper.vue'

export default {
  name: 'RadioRow',
  components: { LockableInputWrapper },
  data() {
    return {
      selectedOptions: this.defaultOptions,
      selectedOption: this.initSelectedOption()
    }
  },
  props: {
    optionSet: {
      required: true,
      type: Array
    },
    defaultOptions: {
      type: Array,
      default() {
        return ['']
      }
    },
    columns: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: 'top'
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    labelPrefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    flexContentStyle() {
      if (!this.columns) {
        return {}
      } else {
        return {
          'flex-basis': `${100 / this.columns}%`
        }
      }
    },

  },
  methods: {
    labelId(option) {
      return this.labelPrefix
      ? `${this.labelPrefix}-${option.label.trim().split(' ').join('-')}`
      : option.label
    },
    initSelectedOption() {
      const defaultOption = this.defaultOptions[0]
      if (this.isOptionLocked(defaultOption)) {
        const lowestUnlockedOption = this.optionSet.find(opt => !opt.locked)
        return lowestUnlockedOption ? lowestUnlockedOption.label : ''
      } else {
        return defaultOption
      }
    },
    isOptionLocked(optionLabel) {
      let option = this.optionSet.find(opt => opt.label === optionLabel)
      return option && option.locked
    }
  },
  watch: {
    selectedOption(option) {
      this.selectedOptions = [option]
    },
    selectedOptions() {
      this.$emit('selectedOptions', this.selectedOptions)
    },
    multiSelect() {
      if (!this.multiSelect) {
        this.selectedOption = this.selectedOptions[0]
        this.$emit('selectedOptions', [this.selectedOption])
      } else {
        this.selectedOptions = [this.selectedOption]
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@material/radio/mdc-radio';
@import '@material/form-field/mdc-form-field';
@import '@material/checkbox/mdc-checkbox';

.radio-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
}

.radio-block {
  flex: 0 1;
}

label {
  margin-bottom: 0;
}

.center-block {
  text-align: center;
  margin: 0;
}

.block-label {
  display: block;
}
.multiselect-input {
}
.mdc-checkbox__checkmark-path{
  stroke: white;
  stroke-width: 5;
}

</style>

<style scoped lang='less'>
/deep/ .lock-label-wrapper {
  padding: 8px;
}
/deep/ .lock-button {
  font-size: 1.5rem;
  padding: 0.05em 0.25em;
}
</style>
